import theme from '../../../Config/theme'
import config from '../../../Config/config'

import {
    Flex,
    Container,
    Stack,
    Heading,
    Text,
    Input,
    InputGroup,
    InputLeftElement,
    useColorModeValue
} from '@chakra-ui/react'

import CustomHighlight from '../../../Components/Elements/CustomHighlight'

import { FaSearch } from "react-icons/fa"

const Hero = ({ query, setQuery }) => {
    const inputBgColor = useColorModeValue('gray.50', 'gray.900')
    const borderColor = useColorModeValue(theme.borderColor.borderColorLight, theme.borderColor.borderColorDark)

    return (
        <Flex w={'full'} h={'40vg'}
            py={10}
            mb={10}
            borderBottom={'1px'}
            borderColor={borderColor}
            //background={`url("data:image/svg+xml,%3Csvg width='52' height='26' viewBox='0 0 52 26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffb562' fill-opacity='0.4'%3E%3Cpath d='M10 10c0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4v2c-3.314 0-6-2.686-6-6 0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6zm25.464-1.95l8.486 8.486-1.414 1.414-8.486-8.486 1.414-1.414z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E");`}
            backgroundImage={`linear-gradient(rgba(0, 0, 0, 0.4),rgba(0, 0, 0, 0.4)), url('${config.POLICY_HERO_BACKGROUND_IMAGE}')`}
            backgroundSize={'cover'}
            backgroundPosition={'center center'}
            backgroundAttachment={'fixed'}
        >
            <Container
                maxW={'3xl'}
                py={10}
            >
                <Stack direction={'column'} textAlign={'center'} spacing={5}>
                    <Heading fontSize={'4xl'} fontWeight={700} color={'white'}>
                    <CustomHighlight query={['Frequently Asked Questions']} color={'white'}>Frequently Asked Questions</CustomHighlight>
                    </Heading>
                    <Text fontSize={'2xl'} fontWeight={600} color={'white'}>Have questions? We're here to help.</Text>
                    <InputGroup>
                        <InputLeftElement>
                            <FaSearch />
                        </InputLeftElement>
                        <Input
                            placeholder={'Search'}
                            borderRadius={'full'}
                            focusBorderColor={theme.default.defaultColor}
                            bgColor={inputBgColor}
                            border={'1px'}
                            borderColor={borderColor}
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            _hover={{}}
                        />
                    </InputGroup>
                </Stack>
            </Container>
        </Flex>
    )
}

export default Hero